// extracted by mini-css-extract-plugin
module.exports =  {"cardTitle":"style-module_cardTitle__sNpbXeqWn0si0sI0tTeS"};